import { topicItems } from '@/mocks/homepage';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">热门话题</h2>
          <p className="text-sm text-foreground-500">大家都在讨论的漫画热点</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3 max-w-3xl mx-auto">
          {topicItems.map((item) => (
            <span
              key={item.id}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium cursor-pointer transition-transform hover:scale-105 whitespace-nowrap ${item.color}`}
            >
              <span>{item.name}</span>
              <span className="text-xs opacity-70">{item.heat}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}